<template>
  <div class="order-list table-container">
    <div class="search-bar seprator">
      <div>
        <el-select style="width:150px;" v-model="searchForm.express_company_id" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="物流公司">
          <el-option v-for="(item,i) in expressCompanyList" :key="i"
                     :label="item.name"
                     :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <el-select style="width: 105px" v-model="searchForm.monitor_type" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="监控类型">
          <el-option v-for="(item,i) in monitorTypeOption" :key="i"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div>
        <el-select style="width:105px;" v-model="searchForm.monitor_group" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="分组">
          <el-option v-for="(item,i) in monitorGroupList" :key="i"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div>
        <el-select style="width:100%;" v-model="searchForm.related_merchant_id" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="商家">
          <el-option v-for="(item,i) in businessOption" :key="i"
                     :label="item.merchant_name"
                     :value="item.merchant_id"></el-option>
        </el-select>
      </div>
      <div>
        <el-select style="width:8rem" v-model="searchForm.monitor_flag" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="监控状态">
          <el-option label="监控状态" value=""></el-option>
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="0"></el-option>
        </el-select>
      </div>
      <div>
        <Created
          :expressTypeOption="expressTypeOption"
          :businessOption="businessOption"
          :monitorTypeOption="monitorTypeOption"
          :expressCompanyList="expressCompanyList"
          :monitorGroupList="monitorGroupList"
          v-on:success="search">
          <el-button type="primary">新增监控</el-button>
        </Created>
      </div>
    </div>
    <div class="search-bar seprator">
      <div style="display:flex;align-items:center;">
        <span>
            {{totalCount}}个监控&nbsp;&nbsp;
        </span>
        <!--<el-button style="width:70px;" v-show="mailList.filter(i=>i.isSelected).length" :loading="multipleUpdating" class="block btn-14" type="info" @click="updateMultipleMail()">批量更新</el-button>-->
      </div>
      <div style="display:flex;align-items:center;">
        <div style="margin:0 5px;display: flex;align-items: center;">
          <el-select style="width:110px;" v-model="timeRangeType" class="combo-left mobile-select">
            <el-option label="创建时间" :value="1"></el-option>
            <!--<el-option label="更新时间" :value="2"></el-option>-->
          </el-select>
          <span class="combo-right">
                  <el-date-picker style="margin-right:5px;" format="yyyy-MM-dd HH:mm" v-model="timeRange"
                                  type="datetimerange" range-separator="至" start-placeholder="开始时间"
                                  end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']"
                                  @change="handleTimeChange">
                  </el-date-picker>
                </span>
        </div>
        <div style="display:inline-block;">
          <el-input class="commbo-input" style="width:500px;" clearable
                    v-model="searchWord">
            <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择">
              <el-option label="任务" value="1"></el-option>
            </el-select>
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
        </div>
      </div>
    </div>
    <div v-if="!dataList" class="text-center">
      <Loading></Loading>
    </div>
    <div v-if="totalCount > 0" class="table">
      <el-row type="flex" class="header">
        <el-col :lg="4" :xs="8" class="">
          物流
        </el-col>
        <el-col :lg="4" :xs="8" class="">
          监控类型
        </el-col>
        <el-col :lg="10" :xs="14" class="">
          最新状态
        </el-col>
        <el-col :lg="4" :xs="6">
          关联
        </el-col>
        <el-col :lg="2" :xs="6" class="text-right">
          监控状态
        </el-col>
      </el-row>
      <el-row type="flex" v-for="(item,index) in dataList" :key="index">
        <el-col :lg="4" :xs="8" class="">
          <p> {{expressCompanyList.find(x=>x.id==item.express_company_id).name}}</p>
          <span class="pointer">
            <a :href="item.express_link" target="_blank">
               {{item.express_order_id}}
            </a>
           </span>
        </el-col>
        <el-col :lg="4" :xs="8" class="">
          <p :class="item.hit=='1'?'text-red':''"> {{monitorTypeOption.find(x=>x.value==item.monitor_type).label}}</p>
        </el-col>
        <el-col :lg="10" :xs="14" class="">
          <p>
            {{item.latest_response}}
          </p>
        </el-col>
        <el-col :lg="4" :xs="6">
          <p> {{item.related_task_id}} </p>
          <span>{{item.group_tag}}</span>
        </el-col>
        <el-col :lg="2" :xs="6" class="text-right">
          <el-switch
            @change="changeMonitorFlag(item)"
            v-model="item.monitor_flag_bool">
          </el-switch>
        </el-col>
      </el-row>
    </div>
    <div class="yd-pagination" v-if="totalCount / searchForm.limit > 1">
      <el-pagination :page-size="searchForm.limit" :pager-count="5" :current-page.sync="searchForm.page"
                     layout="prev, pager, next"
                     next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import api from '../../../services/api.js'
  import Created from './Create'
  import CollapseBody from './CollapseBody'

  let _ = require('lodash')

  export default {
    name: 'cartList',
    components: {
      CollapseBody: CollapseBody,
      Created: Created
    },
    data() {
      return {
        timeRangeType:1,
        activeName: '',
        totalCount: 0,
        dataList: [],
        searchWord: '',
        keyword_type: '1',
        timeRange: [],
        selectAll: false,
        brandOption: [],
        sortOption: [{label: '创建时间', value: '1'}, {label: '添加用户数', value: '2'}],
        searchForm: {
          page: 1,
          limit: 10,
          transport_id: '',
          monitor_type: '',
          monitor_group: '',
          related_merchant_id: '',
          related_task_id: '',
          monitor_flag: '',
        },
        expressTypeOption: [{label: '商家物流', value: '1'}, {label: '转运物流', value: '2'}, {label: '终端物流', value: '3'}],
        expressCompanyList: [],
        businessOption: [],
        monitorTypeOption: [{label: '物流进展', value: '1'}, {label: '包裹揽收', value: '2'},],
        monitorGroupList: [],
        columns: [
          {name: '创建时间', field: 'create_time', tableFlag: false,},
          {name: '监控关键字', field: 'monitor_keyword', tableFlag: false,},
          {name: '监控开始时间', field: 'monitor_start_time', tableFlag: false,},
          {name: '分组', field: 'group_tag', tableFlag: false,},
          {name: '监控类型', field: 'monitor_type', tableFlag: false,},
          {name: '物流类型', field: 'express_type', tableFlag: true, width: '20%'},
          {name: '物流公司', field: 'express_company_id', tableFlag: false,},
          {name: '物流单号', field: 'express_order_id', tableFlag: false,},
          {name: '物流链接', field: 'express_link', tableFlag: false,},
          {name: '最新状态', field: 'latest_response', width: '20%'},
          {name: '关联', field: 'related_merchant_id', tableFlag: true, width: 'calc(100% - 50%)'},
          {name: '关联任务', field: 'related_task_id', tableFlag: false,},
          {name: '分组', field: 'group_tag', tableFlag: false},
          {name: '监控状态', field: 'monitor_flag', tableFlag: true, width: '150px'},
        ],

      }
    },
    async mounted() {
      this.timeRange = [new Date(new Date().getTime() - 30 * 24 * 3600 * 1000), new Date()];
      let res = await api.getExpressList(this);
      this.expressCompanyList = res.body.result;
      let res2 = await api.getOrdersMerchants(this)
      this.businessOption = res2.body.result;
      let res3 = await api.getMonitorGroupList(this);
      this.monitorGroupList = res3.body.result.map(item => {
        return {value: item, label: item}
      });
      await this.search()

    },
    methods: {
      async changeMonitorFlag(item) {
        let param = {};
        param.id = item.id;
        param.monitor_flag = item.monitor_flag === '1' ? '0' : '1';
        await api.updateMonitor(this, param);
        item.monitor_flag = param.monitor_flag;
        item.monitor_flag_bool = item.monitor_flag == '1' ? true : false;
      },
      // async changeCollapse(index) {
      //   if (index === '') {
      //     return;
      //   }
      //   let param = {id: this.dataList[index].id};
      //   let res = await api.getMonitorLog(this, param);
      //   this.$set(this.dataList[index], 'monitor_log', res.body.result)
      // },
      search(obj) {
        const generateParams = () => {
          let params = {};
          if (this.timeRange && this.timeRange.length) {
            params.start_time = this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
            params.end_time = this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
          }
          params.limit = this.searchForm.limit;
          params.page = this.searchForm.page;

          for (let p in this.searchForm) {
            if (this.searchForm[p])
              params[p] = this.searchForm[p]
          }
          if (this.searchWord) {
            switch (this.keyword_type) {
              case '1':
                params.related_task_id = this.searchWord;
                break;
            }
          }
          return params
        }
        let params = generateParams();
        this.getList(params)
      },
      getList(params) {
        this.dataList = null;
        this.totalCount = null;
        api.getMonitorList(this, params).then((res) => {
          this.dataList = res.body.result.rows.map(item => {
            if (item.create_time) {
              item.date_display = this.generateDateDisplay(item.create_time.split(' ')[0])
              item.time_display = item.create_time.split(' ')[1]
            }
            if (item.monitor_start_time) {
              item.date_display2 = this.generateDateDisplay(item.monitor_start_time.split(' ')[0])
              item.time_display2 = item.monitor_start_time.split(' ')[1]
            }
            item.monitor_flag_bool = item.monitor_flag == '1' ? true : false;
            this.trackPackage(item);
            return item;
          });
          this.totalCount = +res.body.result.total;
        })
      },
      async trackPackage(item) {
        let hit = '0';
        let latest_response = '';
        this.$set(item, 'latest_response', latest_response);
        this.$set(item, 'hit', hit);
        if (new Date(item.monitor_start_time) > new Date() || item.monitor_flag != '1') {
          return
        }
        let res = await api.packageTracking(this, {express_order_id: item.express_order_id});
        let result = res.body.result;
        if (result.length !== 0) {
          latest_response = result[0].context;
          let find = result.find(item => item.context.indexOf(item.monitor_keyword) != -1);
          if (find) {
            hit = '1';
          }
          this.$set(item, 'latest_response', latest_response);
          this.$set(item, 'hit', hit);
        }
      },
      generateDateDisplay(datestring) {
        let today = new Date()
        let yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
        let today_string = this.$moment(today).format('YYYY-MM-DD')
        let yest_string = this.$moment(yesterday).format('YYYY-MM-DD')
        if (datestring == today_string)
          return '今天';
        if (datestring == yest_string)
          return '昨天';
        return datestring
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
  .search-preix {
    width: 6rem;
  }

  .search-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;

    &.seprator {
      justify-content: space-between;
    }
  }

  .table {
    margin-top: 43px;
    overflow-x: auto;
    overflow-y: hidden;

  }

  .yd-pagination {
    margin-top: 30px;
  }

  .redirct {
    font-size: 24px;
    line-height: 33px;
    margin-top: 54px;
    padding-bottom: 70px;

    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }

    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

</style>
<style scoped lang="scss">
  .table-container {
    padding: 0 35px 60px;

    .total {
      .block {
        width: 108px;
        margin-top: 15px;
        margin-bottom: 50px;
      }

      span {
        font-size: 14px;
        color: #333;
        line-height: 26px;
      }

      p {
        font-size: 33px;
        color: #666;
      }
    }

    .header {
      color: #333;
    }

    .table {
      .el-row {
        padding: 0 18px 18px;
        border-bottom: 1px solid #EBEBEB;
        margin-bottom: 18px;
      }

      p {
        font-size: 16px;
        padding-bottom: 5px;
      }

      span {
        color: #666;
      }

      .payInfo {
        font-size: 16px;
        line-height: 26px;
      }
    }

  }

  @media screen and (max-width: 1024px) {
    .table-container {
      padding: 0 0 60px;

      .table {

        .el-row {
          padding: 0 0 18px;
        }

        p {
          line-height: 20px;

        }
      }

      .total {
        .el-row {
          display: inline-block;
        }

        p {
          font-size: 18px;
        }

        .block {
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_monitor/list.vue